'use client'

import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import styles from './InscriptionCard.module.css'
import useWindowSize from '@/utils/hooks/useWindowSize'
import { formatSatsPer } from '@/utils/format-sats'
import formatNumber from '@/utils/format-number'
import useExchangeRate from '@/utils/hooks/useExchangeRate'
import useRuneStats from '@/utils/hooks/useRuneStats'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const RuneCard: FC<{
	slug: string
	inscription: any
	footer?: React.ReactNode
	showSetPfp?: boolean
	showSetSns?: boolean
	subtitle?: string
	onClick?: (evt: any) => void
	selected?: boolean
}> = (props): ReactElement => {
	const { onClick, selected, inscription } = props
	const [_openWarning, _setOpenWarning] = React.useState(false)
	const { isMobile } = useWindowSize()
	const { exchangeRate } = useExchangeRate()

	const { data: runeStats } = useRuneStats(props.slug)

	const [_hover, setHover] = React.useState(false)

	const handleMouseEnter = React.useCallback(() => !isMobile && setHover(true), [isMobile])
	const handleMouseLeave = React.useCallback(() => !isMobile && setHover(false), [isMobile])

	const amt = inscription.amount
	const value = inscription?.satoshi_price / amt
	const { sats, per } = formatSatsPer(value)
	const usd = ((value / 1e8) * exchangeRate).toFixed(2)

	return (
		<div
			className={classNames(
				'border rounded-3xl hover:border-[#B692F6] cursor-pointer overflow-hidden',
				{
					['border-[#B692F6]']: selected,
					['border-transparent']: !selected
				}
			)}
			onClick={onClick}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(onClick)}
		>
			<div
				className={`${styles.mask} ${styles.contentWrapper} overflow-hidden rounded-3xl relative overflow-hidden`}
			>
				<div className="hover:scale-110 rounded-3xl transition duration-500 ease-in-out">
					<div
						className={`${styles.content} h-full w-full left-0 top-0  roundex-3xl object-cover pointer-events-none inline flex flex-col items-center justify-center gap-1 bg-[#1D2939] h-full w-full`}
					>
						<p className={`text-2xl font-bold`}>{formatNumber(inscription?.amount || '0')}</p>
						<p className="text-xs text-neutral-400">
							<span className="text-md text-foreground">{sats}</span> {per}/{runeStats?.symbol}
						</p>
						{usd !== '0.00' && <p className="text-xs text-neutral-400">${usd.toString()}</p>}
					</div>
				</div>
			</div>
			<div className="flex flex-col p-3">
				{props.footer && <div className="mt-2">{props.footer}</div>}
			</div>
		</div>
	)
}

export default RuneCard
